import { render } from "./arehouseAndQuality.vue?vue&type=template&id=ed011630&scoped=true"
import script from "./arehouseAndQuality.vue?vue&type=script&lang=js"
export * from "./arehouseAndQuality.vue?vue&type=script&lang=js"

import "./arehouseAndQuality.vue?vue&type=style&index=0&id=ed011630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed011630"]])

export default __exports__